
// ══════════════════════════════════════════════════════════════════
// EN — reemplaza tu export const booking en el archivo de inglés
// ══════════════════════════════════════════════════════════════════
export const booking = {
  createBooking: "Utwórz rezerwację",
  detailsTitle: "Szczegóły rezerwacji",
  createdOn: "utworzona",
  statusBooked: "Zarezerwowana",
  processing: "Przetwarzanie...",
  reject: "Odrzuć",
  cancelled: "Rezerwacja anulowana",
  guests: "Goście",
  nights: "Noce",
 
  responsibleTitle: "Osoba odpowiedzialna za rezerwację",
  name: "Imię i nazwisko",
  email: "E-mail",
  emailNotProvided: "Nie podano adresu e-mail",
  phone: "Telefon",
  phoneNotProvided: "Nie podano telefonu",
  replyWhatsapp: "Odpowiedz na WhatsApp",
  notes: "Notatka",
  notesEmpty: "Brak notatki",
  notesPlaceholder: "Wewnętrzne notatki do rezerwacji (np. późny przyjazd, łóżeczko, alergie…)",
  notesEdit: "Edytuj notatkę",
  notesSave: "Zapisz",
  notesCancel: "Anuluj",
  notesSaved: "Notatka zaktualizowana",
  notesSaveError: "Nie udało się zapisać notatki",
 
  amountTitle: "Kwota rezerwacji",
 
  // Menu buttons & states
  validatingLink: "Sprawdzanie linku...",
  sendPaymentLink: "Wyślij link do płatności",
  copyPaymentLink: "Kopiuj link do płatności",
  sendingPaymentLink: "Wysyłanie linku do płatności…",
  whatsappSent: "Link do płatności wysłany przez WhatsApp.",
  whatsappSentFallback: "Nie udało się wysłać szablonu. WhatsApp otwarty ręcznie.",
  freeReservationInfo: "Rezerwacja bezpłatna - płatność nie jest wymagana",
  stripeNotConfigured: "Stripe nie jest skonfigurowany",
  changePaymentStatus: "Zmień status płatności",
 
  // Amount status
  amountStatus: "Status kwoty",
  paymentPending: "Oczekuje na płatność",
  paid: "Opłacona",
  rejected: "Odrzucona",
  refunded: "Zwrócona",
  partial: "Płatność częściowa",
 
  // Totals
  subtotal: "Suma częściowa:",
  totalDiscounts: "Rabaty razem:",
  totalTaxes: "Podatki razem:",
  total: "Razem:",
 
  // Payment status modal
  changePaymentStatusHeader: "Zmień status płatności",
  paymentStatusLabel: "Status płatności",
  select: "Wybierz",
  pending: "Oczekująca",
  paidShort: "Opłacona",
  close: "Zamknij",
  saveChanges: "Zapisz zmiany",
 
  // Toastr / Messages
  paymentUrlSuccess: "Adres URL płatności został wygenerowany",
  paymentUrlError: "Błąd podczas generowania adresu URL płatności",
 
  linkGenerated: "Link do płatności został wygenerowany",
  linkRegenerated: "Link do płatności zaktualizowany z powodu zmiany cen",
  linkPriceZero: "Nie można wygenerować linku do płatności dla rezerwacji bezpłatnych ($0)",
  linkNoStripe: "Użytkownik nie skonfigurował Stripe do przyjmowania płatności",
  linkNoProvider: "Nie skonfigurowano dostawcy płatności (Stripe lub Wompi)",  // ✅ NUEVA
  linkValidationFailed: "Nie można wygenerować linku do płatności. Brakuje wymaganych danych.",
  linkValidateError: "Błąd podczas sprawdzania linku do płatności",
  linkValid: "Link do płatności jest prawidłowy",
 
  copySuccess: "Link został skopiowany",
  copied: "Skopiowano!",
  copyError: "Wystąpił błąd podczas kopiowania linku",
  error: "Błąd",
  statusUpdatedSuccess: "Status został zaktualizowany",
  statusUpdatedError: "Błąd podczas aktualizacji statusu płatności",  // ✅ NUEVA
 
  // WhatsApp
  whatsappPayMessage: "Dzień dobry, {name}! Oto link do opłacenia rezerwacji: {url}",
 
  checkinsOf: "Check-in w tej rezerwacji ({done} z {total})",
  completed: "Ukończone",
  pendings: "Oczekujące",
  date: "Data",
  noCheckinsYet: "Goście z tej rezerwacji nie ukończyli jeszcze check-in",
 
  alojamiento: "Obiekt",
};
 
